/* THE NELCO - Kit Room. Shopify build v3. */
document.documentElement.classList.add("js");
var $=function(s){return document.querySelector(s)},$$=function(s){return [].slice.call(document.querySelectorAll(s))};
var clamp=function(v,a,b){return Math.max(a,Math.min(b,v))};
var RM=matchMedia("(prefers-reduced-motion:reduce)").matches;
var NL=window.NELCO||{};

/* ---- toast (shared) ---- */
var toastEl=$("#toast"),toastT;
function toast(m){if(!toastEl)return;toastEl.textContent=m;toastEl.classList.add("on");clearTimeout(toastT);toastT=setTimeout(function(){toastEl.classList.remove("on")},2400)}
window.nelcoToast=toast;

/* ---- category chips: filter the rack and the grid ---- */
var chips=$("#chips"),rackEl=$("#rackEl"),shopGrid=$("#shopGrid");
if(chips)chips.addEventListener("click",function(e){
  var b=e.target.closest("[data-cat]");if(!b)return;
  var cat=b.dataset.cat;
  $$("#chips [data-cat]").forEach(function(x){x.setAttribute("aria-pressed",String(x===b))});
  var show=function(el){el.hidden=!(cat==="All"||el.dataset.cat===cat)};
  if(rackEl)$$("#rackEl > [data-cat]").forEach(show);
  if(shopGrid)$$("#shopGrid > [data-cat]").forEach(show);
  if(rackEl)rackEl.scrollTo({left:0,behavior:RM?"auto":"smooth"});
});

/* ---- rack arrows ---- */
$$(".k-arrow").forEach(function(b){
  b.addEventListener("click",function(){
    if(!rackEl)return;
    var card=rackEl.querySelector(".k-card:not([hidden])");
    var step=card?card.getBoundingClientRect().width+18:320;
    rackEl.scrollBy({left:step*(+b.dataset.dir)*2,behavior:RM?"auto":"smooth"});
  });
});

/* ---- tickers ---- */
var MQ=["MADE IN SMALL RUNS","NAME AND NUMBER ON THE BACK","240 GSM FABRIC","NEVER RESTOCKED","SHIPS IN FOUR DAYS"];
function fillTicker(el,words){
  if(!el)return;
  var run=[];for(var k=0;k<4;k++)run=run.concat(words);
  el.innerHTML=run.map(function(s){return "<span>"+s+"</span>"}).join("");
}
fillTicker($("#marquee"),MQ);
fillTicker($("#heroTicker"),["NEW SEASON KITS","FOOTBALL","STREETWEAR","YOUR NAME ON THE BACK","SMALL RUNS ONLY"]);

/* ---- football: scroll-driven passing move ---- */
var passPath=$("#passPath"),fball=$("#fball"),nodesG=$("#nodes"),netG=$("#net"),
    pitchSec=$("#pitch"),passNo=$("#passNo"),distEl=$("#dist"),goalPop=$("#goalPop");
var PLEN=0,pnodes=[],scored=false;
var NODES=[[96,332,"6"],[292,206,"8"],[466,318,"10"],[626,200,"7"],[786,236,"9"]];
if(passPath&&nodesG){
  PLEN=passPath.getTotalLength();
  passPath.style.strokeDasharray=PLEN;
  passPath.style.strokeDashoffset=PLEN;
  nodesG.innerHTML=NODES.map(function(n){
    return '<g><circle class="pnode" cx="'+n[0]+'" cy="'+n[1]+'" r="15"/><text class="pnum" x="'+n[0]+'" y="'+(n[1]+5)+'">'+n[2]+"</text></g>"}).join("");
  pnodes=$$("#nodes .pnode");
}
function pitchTick(){
  if(!passPath||!pitchSec)return;
  var r=pitchSec.getBoundingClientRect(),span=r.height-innerHeight;
  if(span<=0)return;
  var t=clamp(-r.top/span,0,1);
  passPath.style.strokeDashoffset=PLEN*(1-t);
  var pt=passPath.getPointAtLength(PLEN*t);
  fball.setAttribute("transform","translate("+pt.x+","+pt.y+") rotate("+1200*t+")");
  var done=0;
  pnodes.forEach(function(el,i){
    var n=NODES[i],near=Math.hypot(n[0]-pt.x,n[1]-pt.y)<34,past=pt.x>n[0]-6;
    if(past)done++;
    el.classList.toggle("lit",near||past);
  });
  passNo.textContent=Math.min(done,5)+" / 5";
  distEl.textContent=Math.round(78*t)+" m";
  if(t>.965&&!scored){scored=true;netG.classList.add("swish");goalPop.classList.add("on");setTimeout(function(){netG.classList.remove("swish")},800)}
  if(t<.9&&scored){scored=false;goalPop.classList.remove("on")}
}

/* ---- basketball ---- */
var courtSvg=$("#courtSvg"),bball=$("#bball"),bnet=$("#bnet"),shooter=$("#shooter"),shotArc=$("#shotArc");
var HOOP=[590,206],px=190,flying=false,pts=0,made=0,shots=0,streak=0;
function placeShooter(){
  if(!shooter)return;
  shooter.setAttribute("transform","translate("+px+",392)");
  if(!flying)bball.setAttribute("transform","translate("+(px+22)+",336)");
  var mx=(px+HOOP[0])/2,my=Math.min(90,220-.28*(HOOP[0]-px));
  shotArc.setAttribute("d","M"+(px+22)+",336 Q"+mx+","+my+" "+HOOP[0]+","+HOOP[1]);
}
function shoot(){
  if(flying||!courtSvg)return;
  flying=true;shots++;
  var sx=px+22,mx=(px+HOOP[0])/2,my=Math.min(90,220-.28*(HOOP[0]-px)),three=px<188;
  var chance=clamp(.94-(HOOP[0]-px)/720,.3,.94),hit=Math.random()<chance;
  var ex=hit?HOOP[0]:HOOP[0]-34,ey=hit?HOOP[1]+8:HOOP[1]-6;
  var dur=RM?1:760,t0=performance.now();
  (function step(now){
    var t=clamp((now-t0)/dur,0,1),
        x=(1-t)*(1-t)*sx+2*(1-t)*t*mx+t*t*ex,
        y=(1-t)*(1-t)*336+2*(1-t)*t*my+t*t*ey;
    bball.setAttribute("transform","translate("+x+","+y+") rotate("+540*t+")");
    if(t<1)requestAnimationFrame(step);else land(hit,three,ex,ey);
  })(t0);
}
function land(hit,three,ex,ey){
  var call=$("#callout");
  if(hit){bnet.classList.add("swish");setTimeout(function(){bnet.classList.remove("swish")},600);
    pts+=three?3:2;made++;streak++;
    call.textContent=(streak>2?"HEATING UP · ":"")+(three?"THREE.":"SWISH.");
  }else{streak=0;call.textContent="OFF THE RIM."}
  call.classList.add("on");setTimeout(function(){call.classList.remove("on")},1600);
  $("#bScore").textContent=pts;$("#bMade").textContent=made+"/"+shots;$("#bStreak").textContent=streak;
  var dur=RM?1:480,t0=performance.now();
  (function drop(now){
    var t=clamp((now-t0)/dur,0,1),y=ey+(376-ey)*t*t,x=ex-(hit?0:60)*t;
    bball.setAttribute("transform","translate("+x+","+y+") rotate("+200*t+")");
    if(t<1)requestAnimationFrame(drop);else{flying=false;placeShooter()}
  })(t0);
}
placeShooter();
if(courtSvg)courtSvg.addEventListener("click",function(e){
  var r=courtSvg.getBoundingClientRect(),x=(e.clientX-r.left)/r.width*700;
  if(flying)return;
  if(Math.abs(x-px)<70)shoot();else{px=clamp(x,60,470);placeShooter()}
});
if($("#shootBtn"))$("#shootBtn").addEventListener("click",shoot);

/* ---- home personalise preview: name + number on the print plate ---- */
var nameIn=$("#nameIn"),numIn=$("#numIn"),custName=$("#custName"),custNum=$("#custNum");
function drawKit(){
  if(!custName)return;
  var nm=((nameIn&&nameIn.value)||"").toUpperCase().replace(/[^A-Z0-9 .'-]/g,"").slice(0,12);
  var nu=((numIn&&numIn.value)||"").replace(/[^0-9]/g,"").slice(0,2);
  custName.textContent=nm||"YOUR NAME";
  custName.style.fontSize=nm.length>9?"0.72em":"";
  custNum.textContent=nu||"07";
  var left=$("#nameLeft");if(left)left.textContent=(12-nm.length)+" left";
}
if(nameIn||numIn){
  if(nameIn)nameIn.addEventListener("input",function(){
    nameIn.value=nameIn.value.toUpperCase().replace(/[^A-Z0-9 .'-]/g,"").slice(0,12);drawKit()});
  if(numIn)numIn.addEventListener("input",function(){
    numIn.value=numIn.value.replace(/[^0-9]/g,"").slice(0,2);drawKit()});
  drawKit();
}

/* ---- fit finder ---- */
var SCALE=(NL.sizeScale&&NL.sizeScale.length?NL.sizeScale:["S","M","L","XL","2XL"]);
var sizeRow=$("#sizeRow"),sizeBig=$("#sizeBig"),lastPick=null;
if(sizeRow){
  sizeRow.innerHTML=SCALE.map(function(s){return '<div class="sizecell" data-s="'+s+'">'+s+"</div>"}).join("");
  sizeRow.style.gridTemplateColumns="repeat("+SCALE.length+",1fr)";
}
var fitBias=0;
function fitCalc(){
  if(!$("#hIn"))return;
  var h=+$("#hIn").value,c=+$("#cIn").value,last=SCALE.length-1;
  $("#hVal").textContent=h+" cm";$("#cVal").textContent=c+" in";
  var i=c<35?0:c<38?1:c<41?2:c<44?3:c<47?4:5;
  i=Math.min(i,last);
  if(h>=188&&i<last)i++;
  i=clamp(i+fitBias,0,last);
  var picked=SCALE[i];
  $$(".sizecell").forEach(function(el){el.classList.toggle("on",el.dataset.s===picked)});
  if(sizeBig&&picked!==lastPick){
    sizeBig.textContent=picked;
    sizeBig.classList.remove("bump");void sizeBig.offsetWidth;sizeBig.classList.add("bump");
  }
  lastPick=picked;
  var len=[26,27,28,29,30,31][Math.min(i,5)],chest=[36,38,40,42,44,46][Math.min(i,5)];
  $("#fitNote").innerHTML="Take a <b>"+picked+"</b>: "+chest+"&Prime; chest and "+len+"&Prime; length on the garment"
    +(h>=188?", sized up for your height":"")
    +(fitBias===1?". Oversized picked, so one size up.":fitBias===-1?". Tight picked, so one size down.":".");
}
if($("#hIn")){
  $("#hIn").addEventListener("input",fitCalc);
  $("#cIn").addEventListener("input",fitCalc);
  $("#fitSeg").addEventListener("click",function(e){
    var b=e.target.closest("button");if(!b)return;
    fitBias=+b.dataset.f;$("#fVal").textContent=b.textContent;
    $$("#fitSeg button").forEach(function(x){x.setAttribute("aria-pressed",String(x===b))});
    fitCalc();
  });
  fitCalc();
}

/* ---- timeline ---- */
var TL=[["Day 0","Order lands","Your size, design and any name or number go straight onto the cut sheet. Nothing is picked from a warehouse - that shirt does not exist yet.",0],
["Day 1-2","Panels cut","Fabric is cut flat in a small lay. Off-cuts are reused instead of thrown away.",2],
["Day 3-4","Print and sublimate","Names and numbers are dyed into the fibre under heat. This is the step that decides whether a shirt still looks new in year three.",4],
["Day 5-6","Stitched and taped","Side seams, taped shoulders, double-needle hem. One tailor takes a shirt from panel to finished piece.",6],
["Day 7-8","Checked and shipped","Every shirt is measured against the size chart before it is folded. Then it is on a courier to you.",8]];
var tl=$("#tl"),tlFill=$("#tlFill"),dayBig=$("#dayBig"),tlSteps=[];
if(tl){
  tl.insertAdjacentHTML("beforeend",TL.map(function(s){
    return '<div class="tl-step"><div class="tl-d">'+s[0]+'</div><div class="tl-t">'+s[1]+'</div><div class="tl-x">'+s[2]+"</div></div>"}).join(""));
  tlSteps=$$(".tl-step");
}
function tlTick(){
  if(!tl)return;
  var r=tl.getBoundingClientRect(),t=clamp((.62*innerHeight-r.top)/(.9*r.height),0,1);
  tlFill.style.height=100*t+"%";
  var lastOn=0;
  tlSteps.forEach(function(el,i){var on=t>=i/tlSteps.length;el.classList.toggle("on",on);if(on)lastOn=i});
  if(dayBig)dayBig.textContent=t>=.999?"8":TL[lastOn][3];
}

/* ---- scroll driver ---- */
var prog=$("#progbar"),ticking=false;
function frame(){
  var h=document.documentElement.scrollHeight-innerHeight;
  if(prog)prog.style.transform="scaleX("+clamp(scrollY/(h||1),0,1)+")";
  pitchTick();tlTick();ticking=false;
}
addEventListener("scroll",function(){if(!ticking){ticking=true;requestAnimationFrame(frame)}},{passive:true});
addEventListener("resize",frame);
frame();

/* ---- reveals + counters ---- */
var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add("in");io.unobserve(e.target)}})},{threshold:.15});
$$(".reveal").forEach(function(el){io.observe(el)});
var io2=new IntersectionObserver(function(es){es.forEach(function(e){
  if(!e.isIntersecting)return;
  io2.unobserve(e.target);
  var target=+e.target.dataset.count;if(!isFinite(target))return;
  var t0=performance.now(),dur=RM?1:1100;
  (function run(now){var t=clamp((now-t0)/dur,0,1);e.target.textContent=Math.round(target*(1-Math.pow(1-t,3)));if(t<1)requestAnimationFrame(run)})(t0);
})},{threshold:.5});
$$("[data-count]").forEach(function(el){io2.observe(el)});